export var defaultProps = {
    close: true,
    footer: null,
    footerStyle: {},
    bodyStyle: {},
    titleStyle: {},
    style: {},
    title: null,
    visible: false,
    width: 256,
    zIndex: 1000,
    height: 256,
    mask: true,
    maskClosable: true,
    maskStyle: {},
    push: { distance: 180 },
    onClose: function () { },
    afterVisibleChange: function (e) { },
    getContainer: null,
    placement: 'right',
};
